var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasTitle)?_c('Title'):_vm._e(),_vm._v(" "),_vm._t("info")],2)}
var staticRenderFns = []

export { render, staticRenderFns }